import styled from 'styled-components'
import { SerifTitle } from '../SerifTitle/SerifTitle'

export const HomePageLink = styled.a`
  &:hover {
    text-decoration: none;

    ${SerifTitle} {
      text-decoration: underline;
      text-underline-offset: 1.4rem;
      text-decoration-thickness: 0.2rem;
    }
  }
`
